define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/xml",
	"../SizeChart",
	"./Number"
], function(declare,domClass,_,csiHeading,xml,SizeChart,NumberRen) {

	return declare(NumberRen, {
		cssBaseSize: " tableSizeChartRevisedBase",
		cssOffBaseSize: " tableSizeChartRevised",
		highlightSetting: "sizeChartHighlightRevisedDeltaOutOfTolerance",
		idOriginal: "Target",
		idRevised: "Revised",

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: if dimension has blanks and is not base size, then display empty cell
			if(this._isBlank(ctx))
				return false;

			// summary: color red if out of tolerance - make sure to take tolerance format into account
			if (this.highlightSetting && ctx.view.get(this.highlightSetting)) {
				var	node = ctx.getNode();
				var	original = this._getOriginalValue(ctx, node[this.idOriginal]);
				var	bOut = this._isOutOfTolerance(ctx, this._getValue(ctx, h), original);
				domClass.toggle(refNode, "tableSizeChartActualOut", bOut);
			}

			return this.inherited(arguments);
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*csi.view.Tooltip*/tooltip) {
			// summary: no tooltip if blank
			return this._isBlank(ctx) ? null : this.inherited(arguments);
		},

		toTooltipEdit: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: disable edit tooltips since not really using expression
			return null;
		},

		toValueDynamic: function(/*Context*/ctx, /*Heading*/h, /*Number?*/v) {
			// summary: show empty value if the default value
			return (v === undefined) && (this._getValue(ctx, h) == this.DEFAULT) ? "" : this.inherited(arguments);
		},

		_getBaseSizeIndexInRange: function(/*Context*/ctx) {
			// summary: return true if node and index in context represents base size
			var	scrd = ctx.getNode();
			var	index = this._getSizeIndex(ctx, scrd);
			return ctx.view.getSubSizeRangeData(scrd).getBaseIndex(index);
		},

		_getExtraCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if revised value is different than original, then show as editable override; otherwise show as editable with expression
			var	node = ctx.getNode();
			var	bEdit = !ctx.bPrint && !xml.nodeHasFlag(node, xml.NODE_FLAG_FROZEN);
			var	revised = node[this.idRevised];
			var	original = this._getOriginalValue(ctx, node[this.idOriginal]);
			var	cssNew = "";

			if ((revised == this.DEFAULT) || this._equal(revised, original)) {
				if (bEdit) {
					cssNew = csiHeading.CSS_EDITABLE_EXP;
				}

				if (!this._equal(original, node[this.idOriginal])) {
					cssNew += this.cssBaseSize;
				}
			} else {
				if (bEdit) {
					cssNew = csiHeading.CSS_EDITABLE_OVER;
				}

				cssNew += this.cssOffBaseSize;
			}

			return cssNew;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: restrict editing of non-base size revised values if blank
			return this._isBlank(ctx) ? null : this.inherited(arguments);
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if value is different than target, then show as editable override; otherwise show as editable with expression
			if (this._isBlank(ctx)) return null;

			var	css = this.inherited(arguments);
			var	cssExtra = this._getExtraCSS(ctx, h);
			return (css || "") + " " + (cssExtra || "");
		},

		_getOriginalValue: function(/*Context*/ctx, /*Number*/original) {
			// summary: get original value for dimension updated with any change to base size revised value
			var	baseIndex = this._getBaseSizeIndexInRange(ctx);
			var	index = this._getSizeIndex(ctx);

			if ((index != baseIndex) && (original != this.DEFAULT)) {
				// if context not for base size, then try to find SizeChartReviewDimension for its base size and
				// add any difference between the revised and target values
				var	scd = ctx.getNodeParent();
				var	reviewData = ctx.cache.getNodes(scd.ReviewData);

				_.some(reviewData, function(scrd) {
					index = this._getSizeIndex(ctx, scrd);

					if (index == baseIndex) {
						var	base = scrd[this.idOriginal];
						var	rev = scrd[this.idRevised];

						if (rev != this.DEFAULT) {
							original += rev - ((base == this.DEFAULT) ? 0 : base);
						}

						return true;
					}

					return false;
				}, this);
			}

			return original;
		},

		_getSizeIndex: function(/*Context*/ctx, /*Node?*/scrd) {
			// summary: return size index for given SizeChartReviewDimension
			scrd = scrd || ctx.getNode();
			return ctx.cache.getNode(scrd.ReviewSize).SizeIndex;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if revised is set to default, then set value from original
			var	node = ctx.getNode();
			if (node[this.idRevised] != this.DEFAULT) {
				return node[this.idRevised];
			}

			if (SizeChart.bSuggestRevised) {
				return this._getOriginalValue(ctx, node[this.idOriginal]);
			}

			return this.DEFAULT;
		},

		_isBlank: function(/*Context*/ctx) {
			// summary: return true if dimension is blank and size index is not the base size
			return ctx.getNodeParent().Blanks && (this._getSizeIndex(ctx) != this._getBaseSizeIndexInRange(ctx));
		}
	});
});